import { useState } from 'react'
import PlacowkaDetails from './pages/klienci/Placowki/details'
import Powiat from './pages/klienci/Powiat/list'
import { Routes, Route, useLocation, useParams, Navigate } from 'react-router-dom'
import MobileSidebar from './components/MobileSidebar'
import DesktopSidebar from './components/DesktopSidebar'
import MobileHeader from './components/MobileHeader'

import Customers from './pages/system/Customers/list'
import Placowki from './pages/klienci/Placowki/list'
import Miasto from './pages/klienci/Miasto/list'
import Gmina from './pages/klienci/Gmina/list'
import Wojewodztwa from './pages/klienci/Wojewodztwa/list'
import TypyPlacowek from './pages/klienci/TypyPlacowek/list'
import Osoba from './pages/klienci/Osoba/list'
import OsobaDetails from './pages/klienci/Osoba/details'
import Rozmowy from './pages/komunikacja/Rozmowy/list'
import RozmowaAdd from './pages/komunikacja/Rozmowy/add'
import RozmowaDetails from './pages/komunikacja/Rozmowy/details'
import RozmowaEdit from './pages/komunikacja/Rozmowy/edit'
import Dialer from './pages/komunikacja/Rozmowy/dialer'
import Kampanie from './pages/komunikacja/Kampanie/listKampanie'
import KampaniePlacowki from './pages/komunikacja/Kampanie/listPlacowki'
import CustomerDetails from './pages/system/Customers/details'
import CustomerAdd from './pages/system/Customers/add/index'
import CustomerEdit from './pages/system/Customers/edit'
import CustomerContactRecord from './pages/system/Customers/contact-record'

import Leads from './pages/business/Leads/list'
import LeadAdd from './pages/business/Leads/add'
import LeadDetails from './pages/business/Leads/details'
import LeadEdit from './pages/business/Leads/edit'

import Invoices from './pages/ksiegowosc/Invoices/list'
import InvoiceAdd from './pages/ksiegowosc/Invoices/add'
import InvoiceDetails from './pages/ksiegowosc/Invoices/details'
import InvoiceEdit from './pages/ksiegowosc/Invoices/edit'

import Korekty from './pages/ksiegowosc/Korekty/list'
import KorektaAdd from './pages/ksiegowosc/Korekty/add'
import KorektaDetails from './pages/ksiegowosc/Korekty/details'
import KorektaEdit from './pages/ksiegowosc/Korekty/edit'

import Expenses from './pages/ksiegowosc/Expenses/list'
import ExpenseAdd from './pages/ksiegowosc/Expenses/add'
import ExpenseDetails from './pages/ksiegowosc/Expenses/details'
import ExpenseEdit from './pages/ksiegowosc/Expenses/edit'
import Rozliczenia from './pages/ksiegowosc/Rozliczenia/list'
import RozliczeniaDetails from './pages/ksiegowosc/Rozliczenia/details'

import Trainings from './pages/centrumSzkolen/Szkolenia/list'
import TrainingsCalendar from './pages/centrumSzkolen/Szkolenia/kalendarz'
import TrainingAdd from './pages/centrumSzkolen/Szkolenia/add'
import TrainingDetails from './pages/centrumSzkolen/Szkolenia/details'
import TrainingEdit from './pages/centrumSzkolen/Szkolenia/edit'

import Projects from './pages/centrumSzkolen/Projekty/list'
import ProjectAdd from './pages/centrumSzkolen/Projekty/add'
import ProjectDetails from './pages/centrumSzkolen/Projekty/details'
import ProjectEdit from './pages/centrumSzkolen/Projekty/edit'

import Certifications from './pages/centrumSzkolen/Certyfikaty/list'
import CertificationAdd from './pages/centrumSzkolen/Certyfikaty/add'
import CertificationEdit from './pages/centrumSzkolen/Certyfikaty/edit'
import MyTrainings from './pages/centrumSzkolen/MojeSzkolenia/list'
import MyTrainingDetails from './pages/centrumSzkolen/MojeSzkolenia/details'
import MyProjects from './pages/centrumSzkolen/MojeProjekty/list'
import MyProjectDetails from './pages/centrumSzkolen/MojeProjekty/details'
import Dyspozycja from './pages/centrumSzkolen/Dyspozycja/list'
import DyspozycjaAdd from './pages/centrumSzkolen/Dyspozycja/add'
import DyspozycjaDetails from './pages/centrumSzkolen/Dyspozycja/details'
import DyspozycjaEdit from './pages/centrumSzkolen/Dyspozycja/edit'
import WirtualnaTablica from './pages/centrumSzkolen/WirtualnaTablica'
import ZmianyDostepnosci from './pages/centrumSzkolen/ZmianyDostepnosci'

import Memberships from './pages/business/Memberships/list'
import MembershipsAdd from './pages/business/Memberships/add'
import MembershipsDetails from './pages/business/Memberships/details'
import MembershipsEdit from './pages/business/Memberships/edit'

import Schedule from './pages/business/Schedule/list'
import ScheduleAdd from './pages/business/Schedule/Add'
import ScheduleEdit from './pages/business/Schedule/Edit'
import ScheduleDetails from './pages/business/Schedule/Details'

import Settings from './pages/system/Settings/index'
import Uzytkownicy from './pages/system/Uzytkownicy/list'
import UserCreatePage from './pages/system/Uzytkownicy/add'
import UserUpdatePage from './pages/system/Uzytkownicy/edit'

import SingleCustomCollectionList from './pages/system/SingleCustomCollection/list'
import SingleCustomCollectionAdd from './pages/system/SingleCustomCollection/add'
import SingleCustomCollectionEdit from './pages/system/SingleCustomCollection/edit'
import SingleCustomCollectionDetails from './pages/system/SingleCustomCollection/details'

import CustomCollection from './pages/system/CustomCollections/list/index'
import CustomCollectionAdd from './pages/system/CustomCollections/add/index'
import CustomCollectionDetails from './pages/system/CustomCollections/details/index'
import CustomCollectionEdit from './pages/system/CustomCollections/edit/index'

function SingleCustomCollectionListItem() {
	const { collectionId } = useParams()
	return <SingleCustomCollectionList collectionId={collectionId} />
}

function RozmowaDetailsRedirect() {
	const { id } = useParams()
	return <Navigate to={`/komunikacja/rozmowy/details/${id}`} replace />
}

function RozmowaEditRedirect() {
	const { id } = useParams()
	return <Navigate to={`/komunikacja/rozmowy/edit/${id}`} replace />
}

function SettingsUserEditRedirect() {
	const { id } = useParams()
	return <Navigate to={`/system/uzytkownicy/edit/${id}`} replace />
}

export default function App() {
	const [sidebarOpen, setSidebarOpen] = useState(false)
	const location = useLocation()

	return (
		<>
			<div className="min-h-screen bg-gray-100">
				<MobileSidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
				<DesktopSidebar />
				<MobileHeader setSidebarOpen={setSidebarOpen} />

				<main className="py-5 lg:pl-72">
					<div className="px-4 sm:px-6 lg:px-8">
						<Routes location={location}>
							<Route path="/" element={<Navigate to="/klienci/placowki" replace />} />

							<Route path="/system/customers" element={<Customers />} />
							<Route path="/klienci/placowki" element={<Placowki />} />
							<Route path="/klienci/placowki/details/:id" element={<PlacowkaDetails />} />
							<Route path="/klienci/powiat" element={<Powiat />} />
							<Route path="/klienci/miasto" element={<Miasto />} />
							<Route path="/klienci/gmina" element={<Gmina />} />
							<Route path="/klienci/wojewodztwa" element={<Wojewodztwa />} />
							<Route path="/klienci/typy-placowek" element={<TypyPlacowek />} />
							<Route path="/klienci/osoba" element={<Osoba />} />
							<Route path="/klienci/osoba/details/:id" element={<OsobaDetails />} />
							<Route path="/komunikacja/rozmowy" element={<Rozmowy />} />
							<Route path="/komunikacja/rozmowy/add" element={<RozmowaAdd />} />
							<Route path="/komunikacja/rozmowy/details/:id" element={<RozmowaDetails />} />
							<Route path="/komunikacja/rozmowy/edit/:id" element={<RozmowaEdit />} />
							<Route path="/komunikacja/rozmowy/dialer" element={<Dialer />} />
							<Route path="/komunikacja/kampanie" element={<Kampanie />} />
							<Route path="/komunikacja/kampanie/:kampaniaId/placowki" element={<KampaniePlacowki />} />
							<Route path="/klienci/rozmowy" element={<Navigate to="/komunikacja/rozmowy" replace />} />
							<Route path="/klienci/rozmowy/add" element={<Navigate to="/komunikacja/rozmowy/add" replace />} />
							<Route path="/klienci/rozmowy/details/:id" element={<RozmowaDetailsRedirect />} />
							<Route path="/klienci/rozmowy/edit/:id" element={<RozmowaEditRedirect />} />
							<Route path="/klienci/rozmowy/dialer" element={<Navigate to="/komunikacja/rozmowy/dialer" replace />} />
							<Route path="/system/customers/add" element={<CustomerAdd />} />
							<Route path="/system/customers/details/:id" element={<CustomerDetails />} />
							<Route path="/system/customers/edit/:id" element={<CustomerEdit />} />
							<Route path="/system/customers/contact-record/:id" element={<CustomerContactRecord />} />

							<Route path="/leads" element={<Leads />} />
							<Route path="/leads/add" element={<LeadAdd />} />
							<Route path="/leads/details/:id" element={<LeadDetails />} />
							<Route path="/leads/edit/:id" element={<LeadEdit />} />

							<Route path="/ksiegowosc/invoices" element={<Invoices />} />
							<Route path="/ksiegowosc/invoices/add" element={<InvoiceAdd />} />
							<Route path="/ksiegowosc/invoices/details/:id" element={<InvoiceDetails />} />
							<Route path="/ksiegowosc/invoices/edit/:id" element={<InvoiceEdit />} />

							<Route path="/ksiegowosc/korekty" element={<Korekty />} />
							<Route path="/ksiegowosc/korekty/add" element={<KorektaAdd />} />
							<Route path="/ksiegowosc/korekty/details/:id" element={<KorektaDetails />} />
							<Route path="/ksiegowosc/korekty/edit/:id" element={<KorektaEdit />} />

							<Route path="/ksiegowosc/expenses" element={<Expenses />} />
							<Route path="/ksiegowosc/expenses/add" element={<ExpenseAdd />} />
							<Route path="/ksiegowosc/expenses/details/:id" element={<ExpenseDetails />} />
							<Route path="/ksiegowosc/expenses/edit/:id" element={<ExpenseEdit />} />

							<Route path="/ksiegowosc/rozliczenia" element={<Rozliczenia />} />
							<Route path="/ksiegowosc/rozliczenia/:trainerId" element={<RozliczeniaDetails />} />

							<Route path="/centrumSzkolen/szkolenia" element={<Trainings />} />
							<Route path="/centrumSzkolen/szkolenia/kalendarz" element={<TrainingsCalendar />} />
							<Route path="/centrumSzkolen/szkolenia/add" element={<TrainingAdd />} />
							<Route path="/centrumSzkolen/szkolenia/details/:id" element={<TrainingDetails />} />
							<Route path="/centrumSzkolen/szkolenia/edit/:id" element={<TrainingEdit />} />
							<Route path="/centrumSzkolen/projekty" element={<Projects />} />
							<Route path="/centrumSzkolen/projekty/add" element={<ProjectAdd />} />
							<Route path="/centrumSzkolen/projekty/details/:id" element={<ProjectDetails />} />
							<Route path="/centrumSzkolen/projekty/edit/:id" element={<ProjectEdit />} />
							<Route path="/centrumSzkolen/certyfikaty" element={<Certifications />} />
							<Route path="/centrumSzkolen/certyfikaty/add" element={<CertificationAdd />} />
							<Route path="/centrumSzkolen/certyfikaty/edit/:id" element={<CertificationEdit />} />
							<Route path="/centrumSzkolen/moje-szkolenia" element={<MyTrainings />} />
							<Route path="/centrumSzkolen/moje-szkolenia/details/:id" element={<MyTrainingDetails />} />
							<Route path="/centrumSzkolen/moje-projekty" element={<MyProjects />} />
							<Route path="/centrumSzkolen/moje-projekty/details/:id" element={<MyProjectDetails />} />
							<Route path="/centrumSzkolen/dyspozycja" element={<Dyspozycja />} />
							<Route path="/centrumSzkolen/dyspozycja/add" element={<DyspozycjaAdd />} />
							<Route path="/centrumSzkolen/dyspozycja/details/:id" element={<DyspozycjaDetails />} />
							<Route path="/centrumSzkolen/dyspozycja/edit/:id" element={<DyspozycjaEdit />} />
							<Route path="/centrumSzkolen/wirtualna-tablica" element={<WirtualnaTablica />} />
							<Route path="/centrumSzkolen/zmiany-dostepnosci" element={<ZmianyDostepnosci />} />

							<Route path="/memberships" element={<Memberships />} />
							<Route path="/memberships/add" element={<MembershipsAdd />} />
							<Route path="/memberships/details/:id" element={<MembershipsDetails />} />
							<Route path="/memberships/edit/:id" element={<MembershipsEdit />} />

							<Route path="/schedule" element={<Schedule />} />
							<Route path="/schedule/add" element={<ScheduleAdd />} />
							<Route path="/schedule/details/:id" element={<ScheduleDetails />} />
							<Route path="/schedule/edit/:id" element={<ScheduleEdit />} />

							<Route path="/settings" element={<Settings />} />
							<Route path="/system/uzytkownicy" element={<Uzytkownicy />} />
							<Route path="/system/uzytkownicy/add" element={<UserCreatePage />} />
							<Route path="/system/uzytkownicy/edit/:id" element={<UserUpdatePage />} />
							<Route path="/settings/users/add" element={<Navigate to="/system/uzytkownicy/add" replace />} />
							<Route path="/settings/users/edit/:id" element={<SettingsUserEditRedirect />} />

							<Route path="/single-custom-collection/:collectionId" element={<SingleCustomCollectionListItem />} />
							<Route path="/single-custom-collection/:collectionId/add" element={<SingleCustomCollectionAdd />} />
							<Route path="/single-custom-collection/:collectionId/details/:itemId" element={<SingleCustomCollectionDetails />} />
							<Route path="/single-custom-collection/:collectionId/edit/:id" element={<SingleCustomCollectionEdit />} />

							{/* <Route path="/collections/:collectionId" element={<DataViewRoute />} />
							<Route path="/collections/:collectionId/add" element={<CustomItemAdd />} />
							<Route path="/collections/:collectionId/details/:id" element={<CustomItemDetails />} />
							<Route path="/collections/:collectionId/edit/:id" element={<CustomItemEdit />} /> */}

							<Route path="/custom-collections" element={<CustomCollection />} />
							<Route path="/custom-collections/add" element={<CustomCollectionAdd />} />
							<Route path="/custom-collections/details/:id" element={<CustomCollectionDetails />} />
							<Route path="/custom-collections/edit/:id" element={<CustomCollectionEdit />} />
						</Routes>
					</div>
				</main>
			</div>
		</>
	)
}
